





























import zenscroll from 'zenscroll'
import moment from 'moment';

import { Component } from 'vue-property-decorator'
import SectionBase from '@/mixins/SectionBase'
import { API_URL } from '@/config'
import OrderSectionBase from './OrderSectionBase'
import { ORDER_NAMESPACE } from '@/store/mod/order_form'

enum Status {
  READY = 'ready',
  NOT_VALID = 'not-valid',
  NOT_ACCEPTED = 'not-accepted',
  SUBMITTING = 'submitting',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed'
}

@Component({
  mixins: [SectionBase, OrderSectionBase],
})
export default class SectionSubmit extends OrderSectionBase {
  status: Status = Status.READY
  inquiryId = null

  get salesConditionsUrl (): string {
    return `${API_URL}/file/salgsbetingelser.pdf?token=${this.$store.state.auth.token}`
  }

  get pdfUrl (): string {
    return `${API_URL}/inquiry/${this.inquiryId}/pdf?token=${this.$store.state.auth.token}`
  }

  get submitting (): boolean {
    return !this.notValid && this.status === Status.SUBMITTING
  }

  get succeeded (): boolean {
    return !this.notValid && this.status === Status.SUCCEEDED
  }

  get failed (): boolean {
    return !this.notValid && this.status === Status.FAILED
  }

  get notValid (): boolean {
    return this.$validator.errors.count() > 0 || this.status === Status.NOT_VALID
  }

  get notAccepted (): boolean {
    return !this.notValid && this.status === Status.NOT_ACCEPTED
  }

  get accepted (): boolean {
    const accepted = this.value('sales_conditions')
    if (typeof accepted !== 'boolean') {
      throw Error('"sales_conditions" most be boolean')
    }
    return accepted
  }

  get showVacationMessage (): boolean {
    const vacationStart = moment.utc([2018, 6, 5, 14, 0, 0]);
    const vacationEnd = moment.utc([2018, 7, 13, 6, 0, 0]);
    const now = moment.utc();

    return now.isBetween(vacationStart, vacationEnd);
  }

  scrollToFirstError () {
    let topmostError = this.$validator.errors.items[0]
    let topmostErrorEl = document.getElementById(`${topmostError.field}-input`);
    if (!topmostErrorEl) {
      throw new Error(`Field '${topmostError.field}' could not be found`)
    }
    let topmostErrorPos = topmostErrorEl.getBoundingClientRect().top + window.pageYOffset

    for (let error of this.$validator.errors.items) {
      let el = document.getElementById(`${error.field}-input`)
      if (!el) {
        throw new Error(`Field '${error.field}' could not be found`)
      }

      let pos = el.getBoundingClientRect().top + window.pageYOffset
      if (pos < topmostErrorPos) {
        topmostError = error
        topmostErrorEl = el
        topmostErrorPos = pos
      }
    }

    zenscroll.center(topmostErrorEl)
  }

  submitEnabled(): boolean {
    // Submit-button disabled while we are submitting a form
    if (this.status === Status.SUBMITTING) {
      return false
    }

    // If we have submitted a form with success, we must wait for a change in the form
    if (this.status === Status.SUCCEEDED) {
      return this.$store.getters[ORDER_NAMESPACE + '/changed']
    }

    // All other statuses -> we can press the button
    return true
  }

  submit () {
    if (this.accepted || !this.show('sales_conditions')) {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.status = Status.SUBMITTING

          this.$store.dispatch('orderForm/sendInquiry').then(id => {
            this.status = Status.SUCCEEDED
            this.inquiryId = id
          }).catch(error => {
            console.error("Could not post inquiry.")
            this.status = Status.FAILED
          })
        } else {
          this.status = Status.NOT_VALID
          this.scrollToFirstError()
        }
      })
    } else {
      this.status = Status.NOT_ACCEPTED
    }
  }
}
